import React, { useState, useEffect } from 'react';

interface VisualTrackingActivityProps {
  timeLeft: number;
  onInteraction: (data: any) => void;
}

export function VisualTrackingActivity({ timeLeft, onInteraction }: VisualTrackingActivityProps) {
  const [dotPosition, setDotPosition] = useState({ x: 50, y: 50 });

  useEffect(() => {
    const interval = setInterval(() => {
      const newX = 20 + Math.sin(Date.now() / 1000) * 30 + Math.random() * 20;
      const newY = 20 + Math.cos(Date.now() / 1500) * 30 + Math.random() * 20;
      setDotPosition({ x: newX, y: newY });
      onInteraction({ type: 'dot_move', position: { x: newX, y: newY }, timestamp: Date.now() });
    }, 2000);

    return () => clearInterval(interval);
  }, [onInteraction]);

  return (
    <div className="w-full h-80 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl relative border-2 border-blue-200">
      <div className="absolute inset-4 text-center">
        <p className="text-lg font-semibold text-blue-700 mb-4 font-baloo">
          Follow the moving dot with your eyes! 👀
        </p>
        <div
          className="absolute w-6 h-6 bg-red-500 rounded-full shadow-lg transition-all duration-2000 ease-in-out"
          style={{
            left: `${dotPosition.x}%`,
            top: `${dotPosition.y}%`,
            transform: 'translate(-50%, -50%)',
          }}
        >
          <div className="absolute inset-0 bg-red-400 rounded-full animate-ping"></div>
        </div>
      </div>
    </div>
  );
}
